//xfl_tool.js
//for some basic function

//polyfil 部分

//abs 为了数学计算时与复数相同可以调用abs()求模长
if(!Number.prototype.abs)Number.prototype.abs = function(){
    return Math.abs(this);
}

//polyfil toFixed1 number
if(!Number.prototype.toFixed1)Number.prototype.toFixed1 = function(n){
    let factor = 10**n;
    return Math.round(this*factor)/factor;
}

//非枚举属性添加方法原型，超大数组请注意性能
if(!Array.prototype.toFixed1)Object.defineProperty(Array.prototype,'toFixed1',{
	value:function(n){//
		let factor = 10**n;
        let res = new Array(this.length);
        for(let i=0;i<this.length;i++){
            res[i] = isNaN(this[i])?this[i]:this[i].toFixed1(n);//notice number type
        };
        return res;
		
	},
	enumerable:false
});


/** 数组中删除某某个值
 * @param  {function | arr item} search item or a function return boolen
 * @return  {array}  array self
 */
if(!Array.prototype.remove)Object.defineProperty(Array.prototype,'remove',{
	value:function(val){//大矩阵不能这么用，效率低
        if(typeof(val)==='function'){
            for(let i=this.length-1;i>=0;i--){
                if(val(this[i]))this.splice(i,1);
            };
            return this;
        }
		if(this.length>1000)console.warn('large array,please replace it with filter function');
		while(true){
			var index = this.indexOf(val);
			if (index > -1) { 
			  this.splice(index, 1); 
			} else{
				break;
			}
		};
        return this;
	},
	enumerable:false
});
/** 数组清空，通常用于不改变数组的情况
 * @return  {array}  array self
 */
if(!Array.prototype.clear)Object.defineProperty(Array.prototype,'clear',{
	value:function(){
        this.splice(0,this.length);
        return this;
	},
	enumerable:false
});
/** 数组拷贝
 * @param {array} arr copy from
 * @param {boolean} deepClone copy from
 * @return  {array}  array self
 */
if(!Array.prototype.copy_from)Object.defineProperty(Array.prototype,'copy_from',{
	value:function(arr,deepClone = false){
        this.clear();
        let arr2 = deepClone?JSON.parse(JSON.stringify(arr)):arr;
        for(let i of arr2)this.push(i)
        return arr2.length;
	},
	enumerable:false
});






//get search value form url search string
/**
 * @param  {String} search name
 * @param  {String} [defaultValue] decodeURI already
 */
const get_search = function (search,defaultValue) {
    let search_str = window.location.search;
    if (search_str.indexOf(search + '=') == -1) return defaultValue;
    let start_pos = search_str.indexOf(search);
    let end_pos = search_str.indexOf('&', start_pos);
    let value = end_pos != -1 ? search_str.substring(start_pos + search.length + 1, end_pos) : search_str.substr(start_pos + search.length + 1);
    return decodeURI(value)
}
/**
 * @param  {String} name cookie name
 * @param  {String} [defaultValue]
 */
const get_cookie = function(name,defaultValue) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return decodeURIComponent(arr[2]);
    else
      return defaultValue;
  }
/**
 * @param  {String} 文件名或者全路径文件名
 * @param  {String} defaultValue
 */
const get_ext = function(s_,defaultValue){
    let s_array = s_.split('.');
    if(s_array.length<2)return defaultValue;
    let ext = s_array[s_array.length-1];
    if(ext.indexOf('/') + ext.indexOf('\\') >-2)return defaultValue;
    return ext;
}
/**
 * @param  {Number|String number} v  like 2.51 '1.23'
 * @param  {Number} n 
 */
const x_round = function (v, n) {
    // Math.xround = function (v, n) {
    //四舍五入 n位小数
    if (parseFloat(v).toString() == "NaN") {
        console.warn('Not a number,return ori value:' + v);
        return v;
    }
    let n_factor = 10 ** n;
    return Math.round(v * n_factor) / n_factor;
};

const downloadFile = function (content, fileName, type) {
    var base64ToBlob = function (code) {
        let parts = code.split(';base64,');
        let contentType = parts[0].split(':')[1];
        let raw = window.atob(parts[1]);
        let rawLength = raw.length;
        let uInt8Array = new Uint8Array(rawLength);
        for (let i = 0; i < rawLength; ++i) {
            uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
            type: contentType
        });
    };
    var arrayToBlob = function (data) {
        return new Blob([data], {
            type: 'text/plain'
        });

    }
    let aLink = document.createElement('a');
    let blob = type == 'pic' ? base64ToBlob(content) : arrayToBlob(content); //new Blob([content]);
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        aLink.download = fileName;
        aLink.href = URL.createObjectURL(blob);
        aLink.click();
    };
    // msg2_('数据导出完成');
};

//弃用，不能多debounce
// 全局时间戳方案 函数节流,仅运行一次，可直接多次调用
const xfl_debounce = function (fn, wait) {
    if (window.throttle_has_call == undefined || window.throttle_has_call == true) {
        //window.throttle_time = Date.now();//如果有运行过就更新下时间
        window.throttle_has_call = false;
    } else {
        clearTimeout(window.throttle_timer);
    };

    let args = arguments;
    window.throttle_timer = setTimeout(() => fn.apply(this, args), wait);

};

//延迟运行一次，需使用该函数包装原函数调用
const debounce = function (fn, delay) {
    let timer; //借助闭包
    return function () {
        timer && clearTimeout(timer);   
        const context = this,args = arguments;
        timer = setTimeout(() => {
            fn.apply(context, args);//绑定调用
            timer = undefined;
        }, delay)  
    }
};

//刷新间隔节流
const throttle = function (fn, wait) {
    let previous = 0;
    let context, args, timer, remaining;  
    return function() {
      let now = +new Date();
      context = this;
      args = arguments;
      remaining = wait - (now - previous)// 剩余的还需要等待的时间
      if (remaining <= 0) {
        fn.apply(context, args);
        previous = now; // 上一次执行时间
        timer && clearInterval(timer); //如果当前执行了，删除之前的定时
      } else {
        timer && clearInterval(timer);
        timer = setTimeout(function(){
          fn.apply(context, args);
          timer = null;
          previous = +new Date() // 上一次执行时间
        }, remaining) //保持间隔正确
      }
    };
}

const get_fn_name = function (callee) {
    //var fnname =xfl_get_fn_name(arguments.callee)
    //function 定义的函数名
    var _callee = callee.toString().replace(/[\s\?]*/g, ""),
        comb = _callee.length >= 50 ? 50 : _callee.length;
    _callee = _callee.substring(0, comb);
    var name = _callee.match(/^function([^\(]+?)\(/);
    if (name && name[1]) {
        return name[1];
    };
    //变量定义的函数名
    var caller = callee.caller,
        _caller = caller.toString().replace(/[\s\?]*/g, "");
    var last = _caller.indexOf(_callee),
        str = _caller.substring(last - 30, last);
    name = str.match(/var([^\=]+?)\=/);
    if (name && name[1]) {
        return name[1];
    };
    //匿名函数
    return "anonymous"

};

const msg = console.log;

const msg2 = function (str) {
    // $('#info').text(str);
    document.querySelector('#info').textContent = str;
    console.log(str);
}

const msg2_ = function (str, color) {
    color = color || 'inherit';
    var dom = document.querySelector('#info');
    dom.textContent = (dom.textContent + ' / ' + str);
    //dom.style.color = color;
    dom.style.color = color;
    console.log(str);
}

const space = function (n) {
    if (n == undefined) return '&nbsp;'
    return '&nbsp'.repeat(n);
};

//replace
const replaces = function (s, rep_array, place_array) {
    var f_len = (rep_array.length < place_array.length ? rep_array.length : place_array.length);
    for (let i = 0; i < f_len; i++) {
        s = s.replace(rep_array[i], place_array[i]);
    };
    return s;
};


/**
 * @param  {Object} obj Object
 * @param  {String} attr_str attr path like 'person;name;first_name'
 * @param  {String} split_str default ; split
 */
const object_attr = function(obj,attr_str,split_str=';'){
    if(!obj)return obj;
    let pos = attr_str.indexOf(split_str);
    if(pos!=-1){
        return obj[attr_str.slice(0,pos)]!==undefined?object_attr(obj[attr_str.slice(0,pos)],attr_str.slice(pos+1),split_str):undefined;
    }else{
        return obj[attr_str]
    }
}
/**
 * @param  {Object} obj Object
 * @param  {String} attr_str attr path like 'person;name;first_name'
 * @param  {String} split_str default . split
 */
const obj_attr = function(obj,attr_str,split_str='.'){
	if(!obj)return obj;
    let pos = attr_str.indexOf(split_str);
    if(pos!=-1){
        return obj[attr_str.slice(0,pos)]!==undefined?obj_attr(obj[attr_str.slice(0,pos)],attr_str.slice(pos+1),split_str):undefined;
    }else{
        return obj[attr_str];
    }
}

const set_object_attr = function (obj, attr_str, value, split_str) {
    if (split_str == undefined) split_str = ';';
    //MAX_DEPTH=5;
    var p = attr_str.split(split_str);
    switch (p.length) {
        case (1):
            obj[p[0]] = value;
            return obj[p[0]] === value;
        case (2):
            obj[p[0]][p[1]] = value;
            return obj[p[0]][p[1]] === value;
        case (3):
            obj[p[0]][p[1]][p[2]] = value;
            return obj[p[0]][p[1]][p[2]] === value;
        case (4):
            obj[p[0]][p[1]][p[2]][p[3]] = value;
            return obj[p[0]][p[1]][p[2]][p[3]] === value;
        case (5):
            obj[p[0]][p[1]][p[2]][p[3]][p[4]] = value;
            return obj[p[0]][p[1]][p[2]][p[3]][p[4]] === value;
        default:
            console.error('bad par depth');
            return false;
    }
}

/**深拷贝，不拷贝函数，注意vue中响应式变量的名称在代码压缩中会被改名
 * 添加 terser:{keep_classname:true},保持类名不变
 * 注意不处理循环引用
 * @template T
 * @param {T} obj 
 * @returns {T}
 */
const obj_copy = function (obj) {
    let type = typeof(obj);
    if(['function','string','number','boolean','undefined'].indexOf(type)!=-1)return obj;

    let newobj;
    if(type==='object'){
        if(!obj){ //null
            return obj;
        }else if( ['ObjectRefImpl','ComputedRefImpl','RefImpl'].includes(obj.__proto__?.constructor?.name)){
            return obj.value;
        }else{//object or array copy
            newobj =Array.isArray(obj)?[]:{};
            for(let i in obj)newobj[i]= obj_copy(obj[i]);
            return newobj;
        }       
    }else{
        console.warn('Not support obj_deep_copy?',obj);
        // console.log(obj);
        return obj;
    }

}
/**overide=false obj1上有的属性，不合并，obj1上没有，则拷贝obj2,属性为对象则迭代
 * 为什么不反向使用Object.assign，因为依赖是层层递进了解的场景时需要这样
 * notice 数组不合并!
 * @param  {Object} obj1  对象1
 * @param  {Object} obj2  对象2
 * @param  {Boolean} [merge_to_first=false] 是否合并到对象1上
 * @param  {Boolean} [overide=false] 是否覆盖原有属性
 */
const obj_merge = function(obj1,obj2,merge_to_first=false,overide=false){
    //注意数组不merge
    let dist_obj = merge_to_first?obj1:obj_copy(obj1);
    for(let attr in obj2){
        if(!(attr in dist_obj)){//不存在,直接拷贝
            dist_obj[attr] = obj_copy(obj2[attr]);
        }else{
            if(Object.prototype.toString.call(dist_obj[attr]) === '[object Object]' && Object.prototype.toString.call(obj2[attr]) === '[object Object]'){//是纯对象
                obj_merge(dist_obj[attr],obj2[attr],true,overide);
            }else{
                if(overide)dist_obj[attr] = obj2[attr];
            }
        }

    };
    return dist_obj;  
}
/** merge obj1[attr] = obj2[attr]
 * @param  {Object} obj1
 * @param  {Object} obj2
 * @param  {string|Array} attr
 */
const obj_merge_attr=function(obj1,obj2,attr){
    Array.isArray(attr)?attr.forEach(v=>obj_merge_attr(obj1,obj2,v)):obj1[attr]=obj2[attr];
}
/** judge if is the same
 * @param  {Any} a 
 * @param  {Any} b
 */
const obj_eq = (a,b,number_limit=1e-6)=>{
    if(a===b)return true;
    const a_type = typeof(a),b_type = typeof(b);
    if(a_type!==b_type)return false;
    if(a_type==='number')return Math.abs(a -b)<number_limit; 
	if(a_type==='string')return a==b;
    if(Object.keys(a).length !== Object.keys(b).length)return false;            
    for(let i in a){
        if(!obj_eq(a[i],b[i],number_limit))return false;
    }
    return true;
}

/**
 * @param  {Object} data object json data
 * @param  {Number} level expand level default 1
 * @param  {String} pre_str for put before a row,default ' '
 */
const json_stringify = function (data, level, pre_str) {
    if (pre_str == undefined) pre_str = ' ';
    if (level == undefined) level = 1;
    if (level == 0 || typeof (data) !== 'object') return JSON.stringify(data, null, '');
    let str_;
    if (Array.isArray(data)) { //type array
        str_ = "[   \r\n";
        for (var i = 0; i < level; i++) {
            var line_pre_str = pre_str.repeat(i + 1);
            for (let item of data) {
                str_ = str_ + line_pre_str + json_stringify(item, level - 1, pre_str.repeat(2)) + ',' + '\r\n';

            }
            str_ = str_.substr(0, str_.length - 3);
            str_ = str_ + '\r\n' + (pre_str.substr(0, pre_str.length / 2) == pre_str.substr(pre_str.length / 2, pre_str.length) ? pre_str.substr(0, pre_str.length / 2) : '') + ']';
            return str_;
        }
    } else { //type object
        str_ = "{   \r\n";
        for (var i = 0; i < level; i++) {
            var line_pre_str = pre_str.repeat(i + 1);
            for (var item in data) {
                str_ = str_ + line_pre_str + '"' + item + '" :' + json_stringify(data[item], level - 1, pre_str.repeat(2)) + ',' + '\r\n';

            }
            str_ = str_.substr(0, str_.length - 3);
            str_ = str_ + '\r\n' + (pre_str.substr(0, pre_str.length / 2) == pre_str.substr(pre_str.length / 2, pre_str.length) ? pre_str.substr(0, pre_str.length / 2) : '') + '}';
            return str_;
        }


    }

};
/**
 * @param  {Date} date Date object or can convert to Date
 * @param  {String} fmt default "YYYY-mm-dd HH:MM:SS";
 * @return {String} 
 */
const format_date = function(date,fmt){
    let ret;
    date = date || (new Date());
    if(!(date instanceof Date))date = new Date(date);
    fmt = fmt || "YYYY-mm-dd HH:MM:SS";
    const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}
/**
 * @param  {} fmt reduce to use format_date
 * @param  {} date
 */
const date_format = function (fmt, date) { //"YYYY-mm-dd HH:MM:SS"
    let ret;
    fmt = fmt || "YYYY-mm-dd HH:MM:SS";
    date = date || (new Date());
    if(typeof(date)=='number')date = new Date(date);
    const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
};
/**
 * Convert seconds to time str,like 6:59,6min59seconds
 * @param  {Number} t_ unit seconds
 * @return {String} eg 1:05:02
 */
const time_str = function(t_){
    let h,m,s;
    h = Math.floor(t_/3600);
    t_ -= h*3600;
    m = Math.floor(t_/60);
    t_ -= m*60;
    s = Math.round(t_);

    switch(true){
        case h>0 :return h+':'+pad2(m)+':'+pad2(s);
        case m>0 :return  m+':'+pad2(s);
        case t_>=0:return '00:' + pad2(s);
        default:return ''
    }
    function pad2(n){
        return (n>9?'':'0') + n
    }
};
const obj_find_path = function (object, value, split_str) { //return path
    split_str = split_str || ';';
    for (var key in object) {
        if (object[key] == value) return key;
        if (typeof (object[key]) == "object") {
            var temp = obj_find_path(object[key], value, split_str);
            if (temp) return key + split_str + temp;
        }
    }
}

const convertImageToCanvas = function (image, canvas) {
    //var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext("2d").drawImage(image, 0, 0);

    return canvas;
}
const convertCanvasToImage = function (canvas) {
    var image = new Image();
    image.src = canvas.toDataURL("image/png");
    return image;
}

const hide_trigger = function(dom,callback,check_interval){
    if(typeof(dom=='string'))dom = document.querySelector(dom);
    check_interval = check_interval || 300;//300毫秒检测事件
    let check_timer = setInterval(()=>{
        console.log('trigger');
            if(dom.style.display=='none'){
                console.log('hide trigger event!');
                clearInterval(check_timer);
                if(callback)callback();
            }
        },check_interval);
};

const show_hide_trigger = function(dom,callback,check_interval){
    if(typeof(dom=='string'))dom = document.querySelector(dom);
    check_interval = check_interval || 300;//300毫秒检测事件
    let has_show = false;
    let check_timer = setInterval(()=>{
            console.log('trigger');
            if(!has_show && dom.style.display !='none'){
               has_show = true;
            }else{
                if(has_show && dom.style.display =='none'){
                    console.log('show hide trigger event!');
                    clearInterval(check_timer);
                    if(callback)callback();
                }
            }
        },check_interval);
};

const event_trigger = function(event,callback,check_interval){
    check_interval = check_interval || 300;//300毫秒检测事件
    let check_timer = setInterval(()=>{
        console.log('trigger');
            if(event()){
                console.log('event trigger event!');
                clearInterval(check_timer);
                if(callback)callback();
            }
        },check_interval);
};

const map_trigger = function(obj,interval,fn,mode){//异步遍历obj的属性, 可以是array,也可以是object, 并且把值传给fn
    if(!obj){console.warn('obj not valid');return};
    interval = interval || 500;
    mode = mode || 'one-by-one';//setTimeout or setInterval

    let attr_array = [];//[key,value] if array [idx,value]
    for(let i in obj)attr_array.push([i,obj[i]]);
    if(attr_array.length==0){console.warn('map trigger of no attr map,return');return};
    if(attr_array.length==1){fn(attr_array[0]);return;};//防止后面会循环无法clearInterval无效


    let i_timer;
    let attr_idx=0;

    let i_fn = function(){
        fn(attr_array[attr_idx]);
        attr_idx++;
        if(attr_idx>=attr_array.length)clearInterval(i_timer);
        return i_fn;
    };

    i_timer = setInterval(i_fn(),interval);
};

const time_par = function(par){//把带时间单位的参数转为s的数字 '500ms'=0.5
    let type = typeof(par);
    const unit_par ={ns:1e-9,us:1e-6,ms:1e-3,ps:1e-12,fs:1e-15,s:1};
    let unit;
    let value;
    switch(type){
        case "number":return par;
        case "object":value = par.value; unit = par.unit;break;
        case 'string':unit = par.replace(/[0-9.\s]+/,'');value =parseFloat(par);break;
        default:throw new Error('bad time par type:' + type);
    };
    if(unit_par[unit]==undefined)throw new Error('bad time unit:' + unit);
    return value*unit_par[unit];
}

const unit_par = function(par){//把带时间单位的参数转为s的数字 '500Khz'=500e3
    const units ={G:1e-4,g:1e-4,M:1e6,k:1e3,K:1e3,m:1e-3,u:1e-6,n:1e-9,N:1e-9,p:1e-12,P:1e-12,f:1e-15,F:1e-15};
    let value = parseFloat(par);
    if(typeof(par) != 'string'){console.warn('unit par is not str');return value;}
    for(let i in units){
        if(par.indexOf(i)>-1)return value*units[i];
    }
}

//UI function
/**
 * @param  {Object} info {type:div,class:'',style:'',text:''}
 */
const new_ui = function(info){
    if(!info['type']){console.warn('Not set dom tag,and set it div');info['type']='div';}
    let e = document.createElement(info['type']);
    for(let i in info){
        if(i=='type')continue;
        if(i=='text'){e.textContent = info[i];}
        else e.setAttribute(i,info[i]);
    }
    return e;
};

const new_div = function(info){
    info = info||{};
    info['type']='div';
    return new_ui(info);
};

const new_button = function(info){
    info = info ||{};
    info['type'] = 'button';
    return new_ui(info);
};

//simple Event bus,on,emit
class EventBus {
    constructor() {
      //定义事件总线对象
      this.eventList = {};
      this.onceList = {};
    }
    //监听
    on(event, fn) {
      let eventList = this.eventList[event];
      eventList ? eventList.push(fn) : this.eventList[event] = [fn]
    }
    //监听一次
    onOnce(event,fn){
        this.on(event,fn);
        this.onceList[event] = true;
        console.log('eventBus onOnce');
    }   
    off(event,fn){
        let eventList = this.eventList[event];
        if(!eventList){console.warn('No event:' + event);return false};
        let pos = eventList.indexOf(fn);
        if(pos!=-1){
            eventList.splice(pos,1);
            return true;
        }else{
            console.warn('event '+ event + ' not found fun ',fn);
            return false;
        }
    }
  
    destroy(event){//删除所有事件
        console.log('remove event',event,this.eventList[event]);
        delete(this.eventList[event]);
        delete(this.onceList[event]);//仅监听一次的也删除一下
    }
    //触发，订阅
    emit(name, ...args) {
      let res = [];
      this.eventList[name] && this.eventList[name].forEach((fn,idx) => {
        res[idx]=fn(...args)
      });
      if(this.onceList[name]){//如果是只触发一次的监听
            this.destroy(name);
      }
      //保存结果，如果仅有一个，直接返回结果
      return (res = res.filter(v=>v),res.length==1?res[0]:(res.length==0?undefined:res));
    }
  }
  
  /**
   * @param  {Object3D} obj
   * @param  {Object} range like {"position":{"x":[8,25],"y":[8,12]},"rotation":{x:[]}},
   */
  function object3D_in(obj,range){
    for(var pr in range){
        var par_coe = pr == "rotation"?Math.PI/180:1;
        for(var xyz in range[pr]){
            if(obj[pr][xyz]<(range[pr][xyz][0]*par_coe) || obj[pr][xyz]>(range[pr][xyz][1]*par_coe)){
                return false;		
            }			
        }			
    }
    return true;
  };

    /**
   * @param  {Object3D} obj
   * @param  {par} range like {"position":{"x":1,"y":1},"rotation":{x:45,y:90},set_type:'add'},
   * @param  {string} set_type abs or add
   */
     function object3D_set(obj,par_,set_type=undefined){
         let par = obj_copy(par_);
         set_type = set_type || par['set_type'] || 'abs';
         delete(par['set_type'])
        for(var pr in par){
            var par_coe = pr == "rotation"?Math.PI/180:1;
            if(!obj[pr]){
                obj[pr] = par[pr];
                continue;
            }
            for(var xyz in par[pr]){
               if(set_type=='abs')obj[pr][xyz] = par[pr][xyz]*par_coe;	
               if(set_type=='add')obj[pr][xyz] += par[pr][xyz]*par_coe;	
            }			
        }
      };


     function object3D_dis(obj1,obj2){
        let pos1 = obj1.position.clone(),pos2 = obj2.position.clone();
        obj1.getWorldPosition(pos1);
        obj2.getWorldPosition(pos2);
        return pos1.distanceTo(pos2);
     };



  function object_equal(a,b){ 
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);
         if (aProps.length != bProps.length) {
              return false;
         }
         for (var i = 0; i < aProps.length; i++) {
           var propName = aProps[i]
   
           var propA = a[propName]
           var propB = b[propName]
           if ((typeof (propA) === 'object')) {
             if (this.isObjectValueEqual(propA, propB)) {
                 return true
               } else {
                 return false
               }
           } else if (propA !== propB) {
             return false
           } else { }
         }
       return true
 
  };
  /** notice preload won't render them to dom
   * @param  {Array} arr preLoad arr like '['./a.js','b.css']
   */
  const pre_load = function(arr,path=''){
      if(!Array.isArray(arr))arr=[arr];
      for(let i of arr){
            let cache_xhr = new XMLHttpRequest();
            cache_xhr.open('GET', path+i);
            cache_xhr.send('');
      }
  }

  const euler_to_quaternion = function(euler){
    const x = euler.x, y = euler.y, z = euler.z, order = (euler?.order || 'XYZ').toUpperCase();
		// http://www.mathworks.com/matlabcentral/fileexchange/
		// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
		//	content/SpinCalc.m
		const cos = Math.cos,sin = Math.sin;

		const c1 = cos( x / 2 ),c2 = cos( y / 2 ),c3 = cos( z / 2 );

		const s1 = sin( x / 2 ),s2 = sin( y / 2 ),s3 = sin( z / 2 );
        let res ={};
		switch ( order ) {

			case 'XYZ':
				res.x = s1 * c2 * c3 + c1 * s2 * s3;res.z = c1 * c2 * s3 + s1 * s2 * c3;
				res.y = c1 * s2 * c3 - s1 * c2 * s3;res.w = c1 * c2 * c3 - s1 * s2 * s3;
				break;
			case 'YXZ':
				res.x = s1 * c2 * c3 + c1 * s2 * s3;res.z = c1 * c2 * s3 - s1 * s2 * c3;
				res.y = c1 * s2 * c3 - s1 * c2 * s3;res.w = c1 * c2 * c3 + s1 * s2 * s3;				
				break;
			case 'ZXY':
				res.x = s1 * c2 * c3 - c1 * s2 * s3;res.z = c1 * c2 * s3 + s1 * s2 * c3;
				res.y = c1 * s2 * c3 + s1 * c2 * s3;res.w = c1 * c2 * c3 - s1 * s2 * s3;
    			break;
			case 'ZYX':
				res.x = s1 * c2 * c3 - c1 * s2 * s3;res.z = c1 * c2 * s3 - s1 * s2 * c3;
				res.y = c1 * s2 * c3 + s1 * c2 * s3;res.w = c1 * c2 * c3 + s1 * s2 * s3; 
				break;

			case 'YZX':
				res.x = s1 * c2 * c3 + c1 * s2 * s3;res.z = c1 * c2 * s3 - s1 * s2 * c3;
				res.y = c1 * s2 * c3 + s1 * c2 * s3;res.w = c1 * c2 * c3 - s1 * s2 * s3; 
				break; 
			case 'XZY':
				res.x = s1 * c2 * c3 - c1 * s2 * s3;res.z = c1 * c2 * s3 + s1 * s2 * c3;
				res.y = c1 * s2 * c3 - s1 * c2 * s3;res.w = c1 * c2 * c3 + s1 * s2 * s3; 
				break; 
			default:
				console.warn( 'THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order );

		}
        return res;
  }
  /**judge answer [a,b,c]
   * @param  {Array} right_answer  正确答案
   * @param  {Array} user_answer   用户答案
   * @param  {Boolean} less_is_right 少选也对
   * @return {Array} [Boolean,Array]  [对错，错误详情]
   */
  const judge_answer=function(right_answer,user_answer,less_is_right=false){
    if(!(user_answer instanceof Array))user_answer=[user_answer];
    if(!(right_answer instanceof Array))right_answer=[right_answer];
    if(!right_answer[0] || right_answer.length==0){console.warn('no right anser set');return [true,['没有设置正确答案']];}//设置错误，用户不承担
    let left_judge=true,right_judge = true;
    let detail = {};
    for(let i of right_answer){
        switch(i[0]){
            case '!'://一定不能存在，其实不需要放进去
                if(user_answer.includes(i.slice(1))){
                    left_judge = false;
                    detail[i.slice(1)] = '用户错选'
                };
                break;
            case '~'://选了也不错，不选也没事，容错项
                break;
            default: //一定要存在
                if(!user_answer.includes(i)){
                    detail[i] = '用户漏选';
                    !less_is_right && (left_judge = false);
                };
        }
        //if(!left_judge)break;
    };
    let has_must_answer = false;
    for(let i of user_answer){
        if(!right_answer.includes(i)){//不存在
            if(right_answer.includes('~'+i)){//存在可选里面

            }else{//一定不能存在的
                right_judge = false;
                detail[i.replace('!','')] = '用户错选'
            }
        }else{
            has_must_answer = true;
        }
        //if(!right_judge)break;
    };
    let chk_detail=[];
    for(let i in detail){
        chk_detail.push(detail[i]+':'+i);
    }
    return [left_judge && right_judge && has_must_answer,chk_detail];//
}


//use [fullpath,path,file] = eval(where_am_i)
//引用时确保它是总打包根文件，不然打包后路径改变会有逻辑问题
const where_am_i = `(function where_am_I() {
    const error = 0;
    const rgx = /(?:http|https|file):\\/\\/.*?\\/.\+?\\.js/;
    try {
        error.foo();
        'use eval(get_myself_path)to get it'
    } catch (e) {
        let path =rgx.exec(e.stack)[0];
        let pos = path.lastIndexOf('/');
        return [path,path.slice(0,pos+1),path.slice(pos+1)]
    }
})()`

/**
* 获取当前执行的文件路径 注意打包后可能会有路径逻辑问题
* @function
* @returns {string[]} - [path+file,path,file] 当前执行的文
*/
const get_js_path = function(){
    const stackTrace = new Error().stack; // 获取当前错误的堆栈信息
    const rgx = /((?:http|https|file):.*?).js/g;
	const res = stackTrace.match(rgx);
	let path = res[1]??res[0];
	let pos = path.lastIndexOf('/');
	return [path,path.slice(0,pos+1),path.slice(pos+1)]
}
/**call it like await asleep(10)
 * @param  {Number} t ms
 * @return {Promise}
 */
const asleep = function(t){
    return new Promise((resolve,reject)=>{
        setTimeout(()=>resolve(t),t);
     })
}
/**call it like await let [sleep,done] = asleep_h(10)
 * @param  {Number} t ms
 * @return {Array} [promise,done]
 */
const asleep_h = function(t){
    let done,s = new Date();
    return [new Promise((resolve,reject)=>{
        setTimeout(()=>resolve(t),t);
        done = ()=>resolve(new Date() - s)
     }),done];
     
}
/**Dynamic load js
 * @param  {string} url js路径
 * @param  {Function} callback
 */
function load_js(url, callback) {
    var script = document.createElement('script');
    script.type = "text/javascript";
    if (typeof (callback) != "undefined") {
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            }
        } else {
            script.onload = function () {
                callback();
            }
        }
    }
    script.src = url;
    document.body.appendChild(script);
}
/**Dynamic load css file
 * @param  {string} url js路径
 */
function load_css(url) {
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
}
/** Color string to specific value
 * @param  {String} str_ Color string
 * @return {Object} {r,g,b,h}
 */
const colorParse = function(str_){
    let a = document.createElement('canvas');
    a.width = 1;a.height=1;
    let c = a.getContext('2d');
    c.fillStyle = str_;
    c.fillRect(0,0,1,1);
    let data = c.getImageData(0,0,1,1).data;
    return {r:data[0],g:data[1],b:data[2],h:data[3]}
};
/**数字格式化
 * @param  {Number} number
 * @param  {String} form '#.00' 两位小数 '000.00' 限定位数  '###,###.00' 
 * @return {String} 
 */
const number_format = function (number, form) {
    let forms = form.split('.');
    number = (forms[1] && forms[1].length)?number.toFixed(forms[1].length):(''+number);
    let numbers = number.split('.')
        , leftnumber = numbers[0].split('')
        , exec = function (lastMatch) {
            if (lastMatch == '0' || lastMatch == '#') {
                if (leftnumber.length) {
                    return leftnumber.pop();
                } else if (lastMatch == '0') {
                    return lastMatch;
                } else {
                    return '';
                }
            } else {
                return lastMatch;
            }
    }, str;

    str = forms[0].split('').reverse().join('').replace(/./g, exec).split('').reverse().join('');
    str = leftnumber.join('') + str;

    if (forms[1] && forms[1].length) {
        leftnumber =  new Array(forms[1].length).fill('0');
        if(numbers[1] && numbers[1].length>0)numbers[1].split('').forEach((v,idx)=>leftnumber[idx]=v);
        str += '.' + forms[1].replace(/./g, exec);
    }
    // return str.replace(/.$/, '');
    return str;
};
/**test if val in array,notice v1<=val<=v2
 * @param  {Number} val eg 1
 * @param  {Array} rng eg 5 in [2,4] false, 5 in [1,3,4,6] true
 * @return {Boolean} is_in
 */
const range_in =(val,rng)=>{
    if(rng.length==2)return val>= rng[0] && val <= rng[1];
    for(let i=0,len=rng.length;i<len;i+=2){
        if(val>=rng[i] && val<=rng[i+1])return true;
    };
    return false;
};
/**
 * @description 按压执行事件，周期interval,
 * 停止条件 鼠标弹起，事件返回true,鼠标移出范围外
 * @param  {htmlDom|string} dom dom or selector
 * @param  {function} event  返回true 则停止
 * @param  {Number} interval=100
 */
const press_event = function (dom, event, interval = 100) {
    if (typeof dom === "string") dom = document.querySelector(dom);
    if (!dom || typeof event !== "function") {
        console.error("No dom or event function");
        return;
    };
    let itvl;
    const stop_itvl = ()=>{
        itvl && clearInterval(itvl);
        dom.removeEventListener('mouseup',stop_itvl);
        dom.removeEventListener('mouseout',stop_itvl);
    }
    if(!event()){
        itvl = setInterval(()=>{
            if(event())clearInterval(itvl);
        },interval)
    };
    
    dom.addEventListener('mouseup',stop_itvl);
    dom.addEventListener('mouseout',stop_itvl);
};
/**
 * @description random pick from a array 
 * @param {Array} arr  [1,2,3]
*/
const rnd_pick =(arr)=>arr[Math.floor(arr.length*Math.random())];
/**
 * @description random of range 
 * @param {Array} rng  [min,max]
*/
var rnd_range = (rng)=> Math.round(rng[0] + (rng[1]-rng[0])*Math.random());

/**
 * @description 属性劫持 
 * @param {Object} object   
 * @param {String} attr
 * @param {function} set_fn 设置劫持
 * @param {function} [get_fn] 读取劫持
*/
function hook_obj(object, attr,set_fn,get_fn) {
    let propValue = object[attr];//单独保存
    Object.defineProperty( object, attr, {
        get: function () {
            get_fn && get_fn(propValue);
            return propValue;
        },
        set: function ( value ) {
            if ( propValue !== value ) {
                propValue = value;
                object[attr] = value;
                set_fn && set_fn(value);
            }
        },
        enumerable:true,
    } );
}

//拷贝到
const copyToClip =function(content,tips,fail_fn,success_fn) {
	if (navigator.clipboard && window.isSecureContext) {
		navigator.clipboard.writeText(content).then(
			// 复制成功callback
			function(){
				if(tips == null){
					alert("复制成功");
				}else{
					alert(tips);
				}
			},
			// 复制失败callback
			function(){
				alert("复制失败");
			},
		)
	}else{
        alert('不支持剪贴板')
    }
 }

 //找到子对像位于父对象中的位置
 /**
  * @param  {Object} p_obj  要查找的对象
  * @param  {Any} c_obj     子对象或者值
  * @param  {Any} except_path  排除不用找的属性(深度优先下会节省大量运算)
  * @param  {Boolean} depth_first=false 深度优先或者广度优先
  */
 const find_path = function(p_obj,c_obj,except_path,depth_first=false){
    const has = new Set();
    let cnt=0;
    let except_fn;
    if(except_path){
        let type = typeof(except_path);
        switch(type){
            case 'string':except_fn = (v)=>v===except_path;break;
            case 'object':{
                if(except_path.test && except_path.exec){//正则
                    except_fn = (v)=>except_path.test(v);
                }
            };break;
            case 'function':except_fn = except_path;break;
        }
    }
    //深度优先
    const _f_obj = (p_obj,c_obj,f_path=[],has)=>{
        if(!(p_obj && typeof(p_obj)==='object'))return;
        
        for(let c in p_obj){
            if(except_fn && except_fn(c)) {console.log('skip',c);continue;}
            cnt++;
            let p_c_obj;
            //某些是getter属性 会出错
            try{p_c_obj = p_obj[c];}catch(e){continue;}
             
            if(p_c_obj===c_obj){
                return [...f_path,c]
            }else if(p_c_obj && typeof(p_c_obj)==='object'){
                if(has.has(p_c_obj))continue;
                has.add(p_c_obj);
                let res =  _f_obj(p_c_obj,c_obj,[...f_path,c],has);
                if(res)return res;
            }
        }
    };
    //广度优先
    const has2 = new WeakMap();
    const _f_obj2 = (p_obj_arr,c_obj,has)=>{
        // cnt++;
        let next_cycle = [];
        for(const p_obj of p_obj_arr){
            const father_path = has2.get(p_obj);
            for(let c in p_obj){
                if(except_fn && except_fn(c)) { console.log('skip',c);continue;;}
                cnt++;
                let p_c_obj;
                //某些是getter属性 会出错
                try{p_c_obj = p_obj[c]}catch(e){continue;}
                if(p_c_obj===c_obj){
                    return [...(father_path??[]),c]
                }else if(p_c_obj && typeof(p_c_obj)==='object'){
                    if(has2.get(p_c_obj))continue;
                    has2.set(p_c_obj,[...(father_path??[]),c]);
                    next_cycle.push(p_c_obj)
                }
            };
        };
        return _f_obj2(next_cycle,c_obj,has);
        
    };
    const res = depth_first?_f_obj(p_obj,c_obj,[],has):_f_obj2([p_obj],c_obj,has2);
    console.log('cycle cnt',cnt)
    if(res)return res;
 }

 const dom_no_event = function(dom){
    //阻止dom中的事件传递到场景中
    if(typeof dom == 'string')dom = document.querySelector(dom);
    if(!dom)return;
    let room_mouse_event =['wheel','contextmenu','click','dblclick','dragover','drop','keydown',
    'mousedown','pointerdown','pointermove','pointerup','resize','touchmove','touchstart'];
    for(let i of room_mouse_event){
        dom.addEventListener(i,(event)=>{
            event.stopPropagation();
//             console.log('event be stopped');
            },
        false);
    }
};
/**按照要求把数组内元素进行全组合
 * eg. (['a','b'],2)=>['aa','ab','ba',bb']
 * @param  {Array} A
 * @param  {Number} len
 * @return {Array} res
 */
const  combination = (Arr, len)=>{
    if (len === 0) {
      return [''];
    }
    let res = [];
    for (let i = 0; i < Arr.length; i++) {
      let subComb = combination(Arr, len - 1);
      for (let j = 0; j < subComb.length; j++) {
        res.push(Arr[i] + subComb[j]);
      }
    }
    return res;
  };

  /**
   * 
   * @param {string} text speak text
   * @param {{volume?:number,lang?:string,voiceURI?:string,rate?:number,pitch?:number }} par rate[0.1,10] pitch[0，2] 音高
   * @returns {function} to stop speak
   */
const speaker = (text='无数据',par={})=>{
    if(!window.SpeechSynthesisUtterance){
        console.warn('No web TTL support');
        return ()=>{}
    }
    const sp = new window.SpeechSynthesisUtterance();
    sp.text = text;
    Object.assign(sp,par);
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(sp);
    return ()=>{window.speechSynthesis.cancel();};
}

    /**
     * @param {function} fn - 函数
     * @param {'debouce'|'throttle'|'instant'|undefined} [type=undefined] - 类型
     * @param {number} [delay =100] 默认延时
     * @returns {function}
     */
const delay_fn =(fn,type,delay=100)=>{
        switch(type){
            case 'debounce':return debounce(fn,delay);
            case 'throttle':return throttle(fn,delay);
            case 'instant':
            case undefined:return fn;
            default:console.error('bad delay fn type ' + type)
        }
    }

/**
 * 给parent_dom加一层遮盖，但是露出sub_dom
 * @param {HTMLElement} parent_dom  - parent dom area,can be selector string
 * @param {HTMLElement|HTMLElement[]} [sub_dom]  - sub dom area,can be selector string,
 * @param {string} cover_color 
 * @param {string} except_color 
 */
const create_dom_except_cover_img = (parent_dom,sub_dom,cover_color='rgba(255,255,255,0.5)',except_color='transparent',expand=0)=>{
    if(typeof(parent_dom)=='string')parent_dom = document.querySelector(parent_dom);
    
    if(sub_dom){
        if(!Array.isArray(sub_dom))sub_dom  =[sub_dom];
        sub_dom = sub_dom.map(v=>{
            return typeof(v)=='string'?document.querySelector(v):v;
        })
    }

    if(!parent_dom ){
        throw new Error('No parent dom and sub dom set');
    };
    const p_area = parent_dom.getBoundingClientRect();
    const canvas = document.createElement('canvas');
    // document.body.appendChild(canvas);//debug add
    // debugger;
    canvas.width = p_area.width;
    canvas.height = p_area.height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = cover_color;
    ctx.fillRect(0,0,canvas.width,canvas.height);
    if(sub_dom){
        sub_dom.forEach((v,idx)=>{
            if(v){
                const s_area = v.getBoundingClientRect();
                ctx.fillStyle = except_color;
                const left = s_area.left - p_area.left - expand/2,
                top = s_area.top - p_area.top - expand/2,
                width = s_area.width + expand,
                height = s_area.height + expand;
                ctx.clearRect(left,top,width,height);
                ctx.fillRect(left,top,width,height);
            }else{
                console.warn('bad sub dom set,you mast check it',sub_dom);
            }

        })
    }
  
    return convertCanvasToImage(canvas);
}

export {
    create_dom_except_cover_img,
    delay_fn,
    speaker,
    combination,
    find_path,
    hook_obj,
    rnd_pick,
    rnd_range,
    press_event,
    number_format,
    colorParse,
    asleep,
    asleep_h,
    pre_load,
    where_am_i,
    get_js_path,
    judge_answer,
    time_str,
    euler_to_quaternion,
    object_equal,
    object3D_in,
    object3D_set,
    object3D_dis,
    range_in,
    EventBus,
    get_search,
    get_ext,
    get_cookie,
    x_round,
    xfl_debounce,
    debounce,
    throttle,
    date_format,
    format_date,
    downloadFile,
    obj_copy,
    obj_merge,
    obj_merge_attr,
    obj_eq,
    msg,
    msg2,
    msg2_,
    get_fn_name,
    object_attr,
    obj_attr,
    set_object_attr,
    obj_find_path,
    json_stringify,
    convertCanvasToImage,
    convertImageToCanvas,
    hide_trigger,
    show_hide_trigger,
    event_trigger,
    map_trigger,
    time_par,
    unit_par,
    new_div,dom_no_event,
    load_css,load_js,
}
